import { RearchFeatureNames } from 'access/types';
import { BulkUploadTypes } from 'constants/bulkUpload';
import permissions from 'constants/permissions';
import { FeatureFlags } from 'types';

type BulkAction = {
  label: string;
  description: string;
  href: string;
  feature?: FeatureFlags;
  permissions?: string[];       // ALL must be present (AND)
  permissionsAny?: string[];    // AT LEAST ONE must be present (OR)
  rearchFeatures?: RearchFeatureNames[];
};

export const bulkActions: Record<string, BulkAction> = {
  'salary-revision': {
    label: 'Salary Revision',
    description: 'Revise salary of all your employees, add effective date in bulk',
    href: '/bulk-uploads/salary-revision',
  },
  'addition-deduction': {
    label: 'Addition and Deduction',
    description: 'Add or deduct amounts for multiple employees in bulk',
    href: '/bulk-uploads/addition-deduction-lop',
    permissions: [permissions.BULK_ADDITION_DEDUCTION],
    rearchFeatures: ['isAdditionsDisabled', 'isDeductionsDisabled', 'isLOPDisabled'],
  },
  'full-final-initiation': {
    label: 'Full & Final Initiation',
    description: 'Initiate full and final settlement for employees in bulk',
    href: `/bulk-uploads/initiate?type=${BulkUploadTypes.TYPE_BULK_FNF_INITIATION}`,
    feature: 'bulk-fnf',
    permissions: [permissions.EMPLOYEE_DISMISSAL],
  },
  'full-final-settlement': {
    label: 'Full & Final Settlement',
    description: 'Settle full and final amounts for employees in bulk',
    href: `/bulk-uploads/initiate?type=${BulkUploadTypes.TYPE_BULK_FNF_SETTLEMENT}`,
    feature: 'bulk-fnf',
    permissions: [permissions.EMPLOYEE_DISMISSAL],
  },
  'one-time-payment': {
    label: 'One-Time Payment',
    description: 'Add one-time adhoc earnings for multiple employees in bulk',
    href: `/bulk-uploads/initiate?type=${BulkUploadTypes.TYPE_BULK_ONE_TIME_PAYMENT}`,
    permissionsAny: [permissions.PAYROLL_ADD_ADHOC_PAYMENT, permissions.PAYROLL_PAY_ADHOC_PAYMENT],
    feature: 'bulkOneTimePaymentFlag',
  },
  'compensation-adjustment': {
    label: 'Compensation Adjustment',
    description: 'Add Recurring deductions, VPF, perquisites and flexible benefits in bulk',
    href: `/bulk-uploads/initiate?type=${BulkUploadTypes.TYPE_BULK_COMPENSATION_ADJUSTMENT}`,
    permissions: [permissions.BULK_ADDITION_DEDUCTION],
    feature: 'reArchM3S3',
  },
  'tds-override': {
    label: 'TDS Override',
    description: 'Override TDS amount for employees for a specific payroll month in bulk',
    href: `/bulk-uploads/initiate?type=${BulkUploadTypes.TYPE_BULK_TDS_OVERRIDE}`,
    feature: 'reArchMilestone1',
  },
  'loans-advances': {
    label: 'Loans/Advances',
    description: 'Create loans and advances for multiple employees in bulk',
    href: `/bulk-uploads/initiate?type=${BulkUploadTypes.TYPE_BULK_LOANS_ADVANCES}`,
    permissionsAny: [permissions.PAYROLL_PAY_ADVANCE_SALARY],
    feature: 'bulkLoansAdvances',
  },
};
